import { render, staticRenderFns } from "./GiftsDialog.vue?vue&type=template&id=f5443e40&scoped=true"
import script from "./GiftsDialog.vue?vue&type=script&lang=js"
export * from "./GiftsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5443e40",
  null
  
)

export default component.exports